import { getWorkflows } from 'FormsUI/api/Workflows';
function createAction(name) {
  return `@@workflows/${name}`;
}
export const REQUEST_WORKFLOWS = createAction('REQUEST_WORKFLOWS');
export const RECEIVE_WORKFLOWS = createAction('RECEIVE_WORKFLOWS');
export const SUCCEED_GETTING_WORKFLOWS = createAction('SUCCEED_GETTING_WORKFLOWS');
export const FAIL_GETTING_WORKFLOWS = createAction('FAIL_GETTING_WORKFLOWS');

// Action creators
function requestWorkflows() {
  return {
    type: REQUEST_WORKFLOWS
  };
}
function receiveWorkflows(workflows) {
  return {
    type: RECEIVE_WORKFLOWS,
    workflows
  };
}
function succeedGettingWorkflows() {
  return {
    type: SUCCEED_GETTING_WORKFLOWS
  };
}
function failGettingWorkflows() {
  return {
    type: FAIL_GETTING_WORKFLOWS
  };
}
export function fetchWorkflows() {
  return dispatch => {
    dispatch(requestWorkflows());
    getWorkflows().then(response => {
      dispatch(succeedGettingWorkflows());
      dispatch(receiveWorkflows(response));
    }, () => {
      dispatch(failGettingWorkflows());
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}